// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1Xcua","resendInfoText":"OnGoingPaymentBox_resendInfoText__1j4s0"};